import { IChargeUnit, IKepcoTou, ITouRate } from './algoInterface'

/**
 * 요금 단가로 비율 계산
 * @param {IChargeUnit} chargeUnit 계절별 요금 단가
 * @returns {ITouRate}
 */
const calUnitToRate = (chargeUnit: IChargeUnit): ITouRate => {
  const touRate = {
    spr: {
      minMid: 0,
      minMax: 0,
    },
    sum: {
      minMid: 0,
      minMax: 0,
    },
    fall: {
      minMid: 0,
      minMax: 0,
    },
    win: {
      minMid: 0,
      minMax: 0,
    },
  }

  touRate.spr.minMid = chargeUnit.spr.mid / chargeUnit.spr.min
  touRate.spr.minMax = chargeUnit.spr.max / chargeUnit.spr.min

  touRate.sum.minMid = chargeUnit.sum.mid / chargeUnit.sum.min
  touRate.sum.minMax = chargeUnit.sum.max / chargeUnit.sum.min

  touRate.fall.minMid = chargeUnit.fall.mid / chargeUnit.fall.min
  touRate.fall.minMax = chargeUnit.fall.max / chargeUnit.fall.min

  touRate.win.minMid = chargeUnit.win.mid / chargeUnit.win.min
  touRate.win.minMax = chargeUnit.win.max / chargeUnit.win.min

  return touRate
}

/**
 * 요금제 단가비율 목록으로 평균내기
 * @param {ITouRate[]} rates
 * @returns {ITouRate} 비율 평균
 */
const calAverageRate = (rates: ITouRate[]): ITouRate => {
  const averageRate: ITouRate = {
    spr: { minMid: 0, minMax: 0 },
    sum: { minMid: 0, minMax: 0 },
    fall: { minMid: 0, minMax: 0 },
    win: { minMid: 0, minMax: 0 },
  }

  // 모든 데이터 합산
  rates.forEach((rate) => {
    averageRate.spr.minMid += rate.spr.minMid
    averageRate.spr.minMax += rate.spr.minMax

    averageRate.sum.minMid += rate.sum.minMid
    averageRate.sum.minMax += rate.sum.minMax

    averageRate.fall.minMid += rate.fall.minMid
    averageRate.fall.minMax += rate.fall.minMax

    averageRate.win.minMid += rate.win.minMid
    averageRate.win.minMax += rate.win.minMax
  })

  // 평균 계산
  const totalCount = rates?.length

  averageRate.spr.minMid /= totalCount
  averageRate.spr.minMax /= totalCount

  averageRate.sum.minMid /= totalCount
  averageRate.sum.minMax /= totalCount

  averageRate.fall.minMid /= totalCount
  averageRate.fall.minMax /= totalCount

  averageRate.win.minMid /= totalCount
  averageRate.win.minMax /= totalCount

  averageRate.spr.minMid = Number(averageRate.spr.minMid.toFixed(3))
  averageRate.sum.minMid = Number(averageRate.sum.minMid.toFixed(3))
  averageRate.fall.minMid = Number(averageRate.fall.minMid.toFixed(3))
  averageRate.win.minMid = Number(averageRate.win.minMid.toFixed(3))

  averageRate.spr.minMax = Number(averageRate.spr.minMax.toFixed(3))
  averageRate.sum.minMax = Number(averageRate.sum.minMax.toFixed(3))
  averageRate.fall.minMax = Number(averageRate.fall.minMax.toFixed(3))
  averageRate.win.minMax = Number(averageRate.win.minMid.toFixed(3))

  return averageRate
}

/**
 * 한전요금제 평균내기
 * @param {IKepcoTou[]} kepcoTOUs
 * @returns {ITouRate}
 */
export const calKepcoAverage = (kepcoTOUs: IKepcoTou[]): ITouRate => {
  const rateList: ITouRate[] = kepcoTOUs?.map((tou) =>
    calUnitToRate(tou.chargeUnit)
  )

  return calAverageRate(rateList)
}
